const handLuggageDictionary = require('./dictionaries/hand_luggage');
const commonDictionary = require('./dictionaries/common');
const Tracking = require('./tracking_base');

const HAND_LUGGAGE_ACTIONS = {
    widget: 'widget',
};

const HAND_LUGGAGE_LABELS = {
    allowance_info: 'allowance_info',
};

const ACTION_KEY = 'hand-luggage';

let instance;
class HandLuggageTracking extends Tracking {
    constructor() {
        const dictionary = Odigeo._.merge({}, commonDictionary, handLuggageDictionary);
        super(dictionary, ACTION_KEY);
    }

    trackHandLuggage(params, label, actionName) {
        this.trackEvent({
            action: {
                name: actionName,
                params: {
                    name: ACTION_KEY,
                },
            },
            label: {
                name: label,
                params,
            },
        });
    }

    onProductInfo(params) {
        this.trackHandLuggage(params, HAND_LUGGAGE_LABELS.allowance_info, HAND_LUGGAGE_ACTIONS.widget);
    }
}

module.exports = HandLuggageTracking;
module.exports.getInstance = () => {
    if (Odigeo._.isUndefined(instance)) {
        instance = new HandLuggageTracking();
    }

    return instance;
};
